module.exports = __webpack_public_path__ + "img/rhythmicVillage.69ffb58f.png";